import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import ResetPasswordForm from "../../components/UI/Forms/Wizard Forms/LoginForm/ResetPasswordForm";
import Icons from "../../resources/icons/Icons";
import Strings from "../../resources/Strings";
import { CLIENT_ROUTES } from "../../enums/Enums";
import { NavLink } from "react-router-dom";
import Fonts from "../../resources/fonts/Fonts";
import * as actionsService from "../../services/ActionsService/ActionsService";
import MessageModal from "../../components/UI/Modals/MessageModal/MessageModal";
import EllipseButton from "../../components/UI/Buttons/EllipseButton/EllipseButton";
import classes from "./Login.module.css";

const ResetPassword = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const contentParams = urlParams.get("content")?.replaceAll(" ", "+");
  const [validateError, setValidateError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(Strings.INVALID_URL)
  const [userId, setUserId] = useState(false);

  useEffect(() => {
    if (contentParams) {
      actionsService
        .validateResetPasswordContent(contentParams)
        .then((response) => {
          if (response.data.isSuccess) {
            setUserId(response.data.entity);
            setValidateError(false);
          } else {
            if (response.data.error && response.data.error.errorTitle) {
              setErrorMessage(response.data.error.errorTitle);
            }
            setValidateError(true);
          }
        })
        .catch((error) => {});
    }
  }, [contentParams]);


  return (
    <div className={classes.loginPage}>
      <Grid classes={{ root: classes.root }} container>
        <Grid item xs={4}>
          <div className={classes.formContainer}>
            <img className={classes.logoImg} src={Icons.LOGIN_LOGO}></img>
            {userId && !validateError && <ResetPasswordForm userId={userId} />}
            {validateError && (
              <>
                <div style={{ flexDirection: 'column', textAlign: 'center' }}>
                  <h2 style={{fontFamily: Fonts.ROBOTO_BOLD}}>{Strings.RESET_URL_EXPIRED_HEADER}</h2>
                  <div style={{fontFamily: Fonts.ROBOTO_REGULAR}}>{Strings.RESET_URL_EXPIRED_DESCRIPTION}</div>
                  <div className={classes.loginButton}>
                    <NavLink to={CLIENT_ROUTES.LOGIN} className={classes.link}>
                      <EllipseButton>
                        {Strings.OK}
                      </EllipseButton>
                    </NavLink>
                  </div>
                </div>
              </>
            )}
          </div>
        </Grid>
        <Grid item xs={8}>
          <div className={classes.imgContainer}>
            <div className={classes.divTest}>
              <img
                className={classes.image}
                src={Icons.RESET_PASSWORD_CAR2}
              ></img>
              <div className={classes.title}>{Strings.LOGIN_IMAGE_TITLE}</div>
            </div>
          </div>
        </Grid>
      </Grid>
      <MessageModal/>
    </div>
  );
};

export default ResetPassword;
